declare global {
	interface Window {
		gtag: (
			command: 'config' | 'event' | 'set' | 'js',
			targetOrAction: string | Date,
			params?: Record<string, any>,
		) => void
		dataLayer: any[]
	}
}

const measurementId = import.meta.env.VITE_GA_MEASUREMENT_ID as
	| string
	| undefined

const isConfigured = !!measurementId

let gtagLoaded = false

function loadGtag() {
	if (gtagLoaded || !isConfigured) return
	gtagLoaded = true

	window.dataLayer = window.dataLayer ?? []
	window.gtag = function (...args: any[]) {
		window.dataLayer.push(args)
	}
	window.gtag('js', new Date())
	window.gtag('config', measurementId!, {
		send_page_view: false,
	})

	const script = document.createElement('script')
	script.async = true
	script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`
	document.head.appendChild(script)
}

// Load as soon as the module is imported (once per session)
loadGtag()

export function useAnalytics() {
	function track(event: string, params?: Record<string, any>) {
		if (!isConfigured) {
			if (import.meta.env.DEV) {
				console.debug('[Analytics] track:', event, params)
			}
			return
		}
		window.gtag?.('event', event, params)
	}

	function trackPageView(path: string, title: string) {
		if (!isConfigured) {
			if (import.meta.env.DEV) {
				console.debug('[Analytics] page_view:', path, title)
			}
			return
		}
		window.gtag?.('event', 'page_view', {
			page_path: path,
			page_title: title,
		})
	}

	function identify(userId: string, traits?: Record<string, any>) {
		if (!isConfigured) {
			if (import.meta.env.DEV) {
				console.debug('[Analytics] identify:', userId, traits)
			}
			return
		}
		window.gtag?.('set', 'user_properties', {
			user_id: userId,
			...traits,
		})
	}

	return {
		track,
		trackPageView,
		identify,
	}
}
